import { render, staticRenderFns } from "./LoadNew.vue?vue&type=template&id=0b9e7d10&scoped=true"
import script from "./LoadNew.vue?vue&type=script&lang=js"
export * from "./LoadNew.vue?vue&type=script&lang=js"
import style0 from "./LoadNew.vue?vue&type=style&index=0&id=0b9e7d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e7d10",
  null
  
)

export default component.exports